import { useEffect } from "react";
import esriConfig from "@arcgis/core/config";
import "./App.scss";
import { LoadingContextProvider } from "context/LoadingContext";
import { EsriUrlsContextProvider } from "context/esriUrlsContext";
import { Routes, Route } from "react-router-dom";
import { NotificationContainer } from "react-notifications";
import Loader from "components/Loader";
import ProtectedRoutes from "components/ProtectedRoutes";
// import VehiclePrintableForm from "pages/Home/components/VehiclesAndMaterials/components/printableForms/VehiclePrintableForm";
import RestRoutes from "components/RestRoutes";
import Auth from "pages/Auth";
// import Home from "pages/Home";
import Home from "pages/Home";
// import StorageItem from "pages/StorageItem";
import { LookupsContextProvider } from "context/lookupsContext";
import esriId from "@arcgis/core/identity/IdentityManager";
import { useAuth } from "context/auth";

function App() {
  const [auth] = useAuth();
  useEffect(() => {
    if (auth?.token) {
      const rInfo = {
        expires: localStorage.getItem("expiration"),
        server: `${process.env.REACT_APP_SERVICE_ONLINE}/sharing/rest`,
        token: auth.token,
        userId: localStorage.getItem("username"),
      };
      esriId.registerToken(rInfo);
      esriConfig.portalUrl = process.env.REACT_APP_SERVICE_PORTAL;
    }
  }, [auth.token]);

  return (
    <EsriUrlsContextProvider>
      <LoadingContextProvider>
        <LookupsContextProvider>
          <Loader />
          <NotificationContainer />
          <Routes>
            <Route element={<ProtectedRoutes />}>
              {/* <Route path="/storage" element={<Storage />} /> */}
              {/* <Route path="/storage/inventory" element={<StorageItem />} /> */}
              {/* <Route path="/*" element={<Home />} /> */}
              {/* <Route path="/investors" element={<Home />} /> */}
              <Route path="/*" element={<Home />} />
              <Route path="*" element={<RestRoutes />} />
            </Route>
            <Route path="/auth" element={<Auth />} />
            {/* <Route path="/VehicleForm" element={<VehiclePrintableForm />} /> */}
          </Routes>
        </LookupsContextProvider>
      </LoadingContextProvider>
    </EsriUrlsContextProvider>
  );
}
export default App;
